<template>
	<div>
		<c-dialog ref="dialog" width="1200" mode="slide" mask-close enable-flex @close="dialogFormEditConfirm($refs.outputForm, arguments)" @resolve="editHandle">
			<template #head>
				<div v-if="detailData.task_id" class="m-detail-tag flex-center-cross">
					<label>工单编号：{{detailData.work_code}}</label>
					<c-state dict="testModeQualityDic" tag :value="detailData.test_mode"></c-state>
				</div>
			</template>

			<module :drag="false" gap="6" style="background: #F5F5F5">
				<module-row size="auto">
					<div class="m-detail-box">
						<h5 style="margin-bottom: 15px; font-size: 20px;">{{detailData.process_name}}</h5>
						<div class="total-bar flex-center">
							<div class="total-bar-item flex-grow flex-column flex-center">
								<label>报工数</label>
								<div>{{ detailData.output_count }}</div>
							</div>
							<div class="total-bar-item flex-grow flex-column flex-center">
								<label>良品数</label>
								<div style="color: #00B279;">{{ detailData.fine_count }}</div>
							</div>
							<div class="total-bar-item flex-grow flex-column flex-center">
								<label>不良品数</label>
								<div style="color: #FF5555;">{{ detailData.defects_count }}</div>
							</div>
							<div class="total-bar-item flex-grow flex-column flex-center">
								<label>良品率</label>
								<div>{{ detailData.fine_ratio }}%</div>
							</div>
						</div>
						<c-grid-row column="2">
							<c-grid-col>
								<c-field label="关联任务">{{detailData.task_info}}</c-field>
							</c-grid-col>
							<c-grid-col>
								<c-field label="生产人员">{{detailData.output_user_realname}}</c-field>
							</c-grid-col>
							<c-grid-col>
								<c-field label="产品信息">{{detailData.product_name}} | {{detailData.product_spec}}</c-field>
							</c-grid-col>
							<c-grid-col>
								<c-field label="报工时间">{{detailData.create_date}}</c-field>
							</c-grid-col>
						</c-grid-row>
					</div>
				</module-row>

				<module-row>
					<c-form ref="outputForm" column="3" vertical unit-width="100%">
						<c-title >本次质检信息</c-title>
						<c-form-item label="本次质检数" required>
							<c-input type="number" name="test_count" decimal="6" :range="[0,fine_count]" v-model="test_count" @change="changeTestCount" :disabled="test_mode == 2"></c-input>
						</c-form-item>
						<c-form-item label="质检合格数" required>
							<c-input type="number" name="test_fine_count" decimal="6" :range="[0,test_count]" v-model="test_fine_count" @change="changeFineCount" :disabled="test_mode == 2"></c-input>
						</c-form-item>
						<c-form-item label="质检不合格数" required>
							<c-input type="number" name="test_defects_count" decimal="6" :range="[0,test_count]" v-model="test_defects_count" @change="changeDefectsCount" :disabled="test_mode == 2"></c-input>
						</c-form-item>
						<!--自定义字段数据-->
						<custom-form ref="customForm" work-type="42"></custom-form>

						<c-title v-show="test_defects_count > 0">质检不合格处理信息</c-title>
						<c-form-item v-show="test_defects_count > 0" :label="false" name="test_defects_list" colspan="3">
							<m-operate border>
								<c-button color="main" prepend-icon="tf-add" @click="addRow()" :disabled="(test_defects_count||0)==0">添加一行</c-button>
							</m-operate>
							<c-table ref="test_defects_table" border :paging="false">
								<template #empty>
									<c-empty message="暂无质检不合格处理数据"></c-empty>
								</template>
								<c-table-column label="处理数量" width="120">
									<template #default="{data}">
										<c-input type="stepper" step-controls="side" decimal="6" :range="[0,test_defects_count]" v-model="data.test_defects_count" :disabled="(test_defects_count||0)<=0"></c-input>
									</template>
								</c-table-column>
								<c-table-column label="处理方式" width="100" required>
									<template #default="{data}">
										<c-select name="after_type" :options="afterTypeDic" :clear="false" v-model="data.after_type" :disabled="(data.test_defects_count||0)<=0"></c-select>
									</template>
								</c-table-column>
								<c-table-column label="不合格原因" width="300">
									<template #default="{data}">
										<c-input v-model="data.defects_reasons" :disabled="(data.test_defects_count||0)<=0"></c-input>
									</template>
								</c-table-column>
								<c-table-column label="备注" width="200">
									<template #default="{data}">
										<c-input v-model="data.remark" :disabled="(data.test_defects_count||0)<=0"></c-input>
									</template>
								</c-table-column>
								<c-table-column label="发现日期" width="140">
									<template #default="{data}">
										<c-datetime v-model="data.discovery_date" type="date" format="yyyy-MM-dd" :disabled="(data.test_defects_count||0)<=0"></c-datetime>
									</template>
								</c-table-column>
								<c-table-column type="button" label="操作" width="70">
									<template #default="row">
										<c-table-button icon="tf-trash" @click="row.remove()">删除</c-table-button>
									</template>
								</c-table-column>
							</c-table>
						</c-form-item>
					</c-form>
				</module-row>
			</module>
		</c-dialog>
	</div>
</template>

<script>
import {mapState} from "vuex";

export default {
	computed: {
		// 获取dictName选项数据
		...mapState(['userInfo', 'afterTypeDic', 'testModeQualityDic'])
	},
	data() {
		return {
			detailData: {},
			taskData: {},
			work_id:0,
			task_id:0,
			output_id: 0,
			fine_count:0,
			test_mode:1,
			test_count:0,				//本次质检数
			test_fine_count:null,		//质检合格数
			test_defects_count:null,	//质检不合格数
		}
	},
	// 监听器
	watch: {
		
	},

	methods: {
		/************打开新增/编辑报工弹窗**************/
		open(data) {
			//初始化自定义字段控件
			this.$refs.customForm.init();
			this.$refs.outputForm.clear();
			this.output_id = data.id;
			this.getDetail();
			this.$refs.dialog.open({
				title: '报工质检'
			});
			this.$refs.test_defects_table.setData([]);
		},

		/*******搜索报工详情*******************/
		getDetail() {
			this.request({
				url:'/output/detail',
				data: {
					id: this.output_id
				},
				loading: true,
				success: data => {
					this.detailData = data.detailInfo;
					this.taskData = data.taskInfo;
					data.detailInfo.product_spec = data.detailInfo.product_spec||'-'
					data.detailInfo.task_info = data.detailInfo.process_code + ' | ' + data.detailInfo.process_name;
					//本次质检数默认为报工良品数
					data.detailInfo.test_count = data.detailInfo.fine_count;
					//首检时，默认合格数为报工良品数，不合格数为0；其他检验方式默认为空，由用户自主填写
					if(data.detailInfo.test_mode == 2){
						data.detailInfo.test_fine_count = data.detailInfo.fine_count;
						data.detailInfo.test_defects_count = 0;
					}else{
						data.detailInfo.test_fine_count = null;
						data.detailInfo.test_defects_count = null;
					}
					//工单基本信息
					this.$refs.outputForm.set(data.detailInfo);
					//初始工单ID
					this.work_id = data.taskInfo.work_id;
					//初始话任务
					this.task_id = data.detailInfo.task_id;
					//初始报工良品数（本次质检数范围上限）
					this.fine_count = data.detailInfo.fine_count;
					//初始本次质检数
					this.test_count = data.detailInfo.fine_count;
					if(data.detailInfo.test_mode == 2){
						this.test_fine_count = data.detailInfo.fine_count;
						this.test_defects_count = 0;
					}else{
						this.test_fine_count = null;
						this.test_defects_count = null;
					}
				}
			});
		},
		
		/******添加行数据*********/
		addRow() {
			var rowData = {};
			rowData.discovery_date = new Date().format('yyyy-MM-dd')
			this.$refs.test_defects_table.push(rowData)
		},
		
		/***变更本次质检数***/
		changeTestCount(){
			//调整本次质检数后，合格数和不良品数清零，由用户自主填写
			this.test_fine_count = '';
			this.test_defects_count = '';
		},
		
		/***变更质检合格数量***/
		changeFineCount(){
			this.test_defects_count = parseFloat(((this.test_count || 0) - (this.test_fine_count || 0)).toFixed(2));
		},
		
		/**变更质检不合格数量**/
		changeDefectsCount(){
			this.test_fine_count = parseFloat(((this.test_count || 0) - (this.test_defects_count || 0)).toFixed(2));
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			
			//不合格处理列表
			var test_defects_list = this.$refs.test_defects_table.getData();
			
			this.$refs.outputForm.submit({
				url: '/quality/output/test',
				rule: {
					test_count: data =>{
						if((data.test_count||0) <= 0){
							return "本次质检数必须大于0"
						}else{
							return true;
						}
					},
					test_fine_count: data =>{
						if(data.test_fine_count === null || data.test_fine_count === '' || data.test_fine_count === undefined){
							return "请输入质检合格数"
						}
						var fine = parseFloat(data.test_fine_count) || 0;
						var defects = parseFloat(data.test_defects_count) || 0;
						var count = parseFloat(data.test_count) || 0;
						if(fine == 0 && defects == 0){
							return "质检合格数、不合格数不能同时为0"
						}else if(fine + defects != count){
							return "质检合格数与不良品数之和必须等于本次质检数"
						}else{
							return true;
						}
					},
					test_defects_count: data =>{
						if(data.test_defects_count === null || data.test_defects_count === '' || data.test_defects_count === undefined){
							return "请输入质检不合格数"
						}
						var fine = parseFloat(data.test_fine_count) || 0;
						var defects = parseFloat(data.test_defects_count) || 0;
						var count = parseFloat(data.test_count) || 0;
						if(fine == 0 && defects == 0){
							return "质检合格数、不合格数不能同时为0"
						}else if(fine + defects != count){
							return "质检合格数与不良品数之和必须等于本次质检数"
						}else{
							return true;
						}
					},
					test_defects_list: data => {
						var flag = true;
						if((data.test_defects_count > 0 && test_defects_list.length == 0)){
							return "请填写质检不合格处理信息";
						}else{
							var total_test_defects_count = 0;
							test_defects_list.forEach(item => {
								if(!item.after_type || !item.test_defects_count || (item.test_defects_count<=0)){
									flag = false;
								}else{
									total_test_defects_count = parseFloat(total_test_defects_count)+parseFloat(item.test_defects_count);
								}
							});
							if (!flag) {
								return '请完善不合格处理信息';
							}
							
							if(total_test_defects_count != this.test_defects_count){
								return "处理数量总和与质检不合格数不符，请重新输入"
							}
						}
						return flag||"请完善处理信息";
					},
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = this.output_id;
					data.test_defects_list = test_defects_list;
					//表单自定义字段
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						type: 'success',
						message:'报工质检成功'
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		},
	}
}
</script>

<style lang="stylus" scoped>
	.total-bar {
		height: 74px;
		border-radius: 4px;
		margin-bottom: 10px;
		background: #F9F9F9;

		&-item {
			gap: 14px;

			label {
				font-size: 14px;
				color: #999;
			}

			div {
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
</style>